import { combineReducers } from 'redux';
import { buyNowPayLater, bnplSummary, bnplToken, bnplAccountSummary, bnplLinkedAccounts, bnplMigration } from './bnplReducer';
export default combineReducers({
    buyNowPayLater,
    bnplSummary,
    bnplToken,
    bnplAccountSummary,
    bnplLinkedAccounts,
    bnplMigration
});
